import React from 'react';
import { Base } from '@stepstone-genesis/components';
import { CHPPreview, LABELS_BY_LANG } from '@stepstone/atomic-tem-chp-preview';
import OpenPositionsSection from './sections/OpenPositionsSection';
import { LangContext } from './LangContext';
import { CompanyContext } from './CompanyContext';
// The 8 section types rendered by the shared @stepstone/atomic-tem-chp-preview package
// (D-16 -- do not add per-type entries for these to a local registry). open-positions
// stays CHP-internal (D-05 -- needs live Kinetic job data with no draft/preview
// equivalent). work-at was removed entirely (2026-07-20) -- it was an unimplemented
// stub with zero backing in the real Kinetic API contract, not a real feature.
//
// CHPPreview owns fixed render order and uniform emptiness handling internally (D-19) --
// this component just needs to route each section to the right renderer, not preserve
// caller order or pre-filter empty ones itself.
const PACKAGE_SECTION_TYPES = [
    'hero',
    'about',
    'company-performance',
    'media',
    'story',
    'highlights',
    'benefits',
    'testimonials',
];
function isPackageSection(section) {
    return PACKAGE_SECTION_TYPES.includes(section.type);
}
/**
 * Orchestrates rendering of all Editor-driven sections. The 7 shared types render via a
 * single CHPPreview call (order + emptiness are its concern, D-19); open-positions stays
 * CHP-internal, rendered after, matching the fixed sequence CHP's own
 * mapBffToEditorContent.ts has always produced.
 */
const EditorContent = ({ data, lang, companyId, numericCompanyId, companyName, hasReportButtonAbove, }) => {
    const packageSections = [];
    let openPositionsSection;
    for (const section of data.sections) {
        if (!section.data) {
            console.warn(`[EditorContent] Section "${section.type}" has no data, skipping.`);
            continue;
        }
        if (section.type === 'open-positions') {
            openPositionsSection = section;
            continue;
        }
        if (isPackageSection(section)) {
            packageSections.push(section);
            continue;
        }
        console.warn(`[EditorContent] Unknown section type: "${section.type}"`);
    }
    return (React.createElement(CompanyContext.Provider, { value: { companyId, numericCompanyId, companyName } },
        React.createElement(LangContext.Provider, { value: lang },
            React.createElement(Base, { "data-testid": "editor-content", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'spaceXxl',
                    ...(!hasReportButtonAbove && { paddingTop: 'spaceXxl' }),
                } },
                React.createElement(CHPPreview, { sections: packageSections, labels: LABELS_BY_LANG[lang] }),
                openPositionsSection && (React.createElement(OpenPositionsSection, { data: openPositionsSection.data }))))));
};
export default EditorContent;
